import { ActionButtonProps } from "@able/react/dist/ActionButton";
import Spacing from "@able/react/dist/Spacing";
import TextStyle from "@able/react/dist/TextStyle";
import { MouseEventHandler, PropsWithChildren } from "react";
import { DataActionsProps } from "../DataActions";
import DynamicAdjustableList from "../DynamicAdjustableList/DynamicAdjustableList";
import { PillProps } from "../Pill";
import { PopoverMultiSelectProps } from "../PopoverMultiselect/PopoverMultiselect";
import { AbleCommonProps } from "../Types";
import { ableTextAlias } from "../util/able-migration";
import getFilterActionComponent from "./Data.helpers";
import "./style.scss";

export type DataFilterType = {
    type: "PopoverMultiSelect" | "Pill" | "ActionButton",
    props: PopoverMultiSelectProps | PillProps | ActionButtonProps
}

export type DataFilterProps = {
    onClickAll?: MouseEventHandler<HTMLElement>;
    filters?: DataFilterType[];
    onSelectFilterItem?: PillProps['onSelect'];
} & Pick<DataActionsProps, 'buttonRef'> & AbleCommonProps & PropsWithChildren;

const DataFilters = ({ onClickAll, filters = [], developmentUrl, buttonRef }: DataFilterProps) => {
    return (
        <Spacing bottom="spacing2x" className={["ted-ui-FilterData"]}>
            <Spacing bottom="spacing1nHalf">
                <TextStyle alias={ableTextAlias("Label")} element="h3">Filter by</TextStyle>
            </Spacing>
            <DynamicAdjustableList allBtnRef={buttonRef} allButtonLabel="All filters ..." onClickAllButton={onClickAll} className="ted-ui-FilterData-container">
                {filters.map(getFilterActionComponent(developmentUrl as string, 'filter'))}
            </DynamicAdjustableList>
        </Spacing>
    )
};

DataFilters.displayName = "DataFilters";



export default DataFilters;